import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@sc/ui-components';
import { AbstractSnackBarData } from '../../types/snackbar-data';

@Component({
  selector: 'sc-snackbar-success',
  styleUrls: ['./snackbar-success.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslateModule],
  template: `
    <div
      class="container"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="sc-bottom-snackbar-title"
    >
      <p
        tabindex="-1"
        class="hide-focus-outline"
        role="heading"
        aria-level="1"
        tabindex="-1"
      >
        <span>🎉</span>
        <span id="sc-bottom-snackbar-title" class="msg">{{
          data.message
        }}</span>
      </p>

      <button type="button" (click)="onCloseClick()">
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeSnackbar' | translate
        }}</span>
        <sc-icon name="close"></sc-icon>
      </button>
    </div>
  `,
})
export class SnackbarSuccessComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: AbstractSnackBarData) {}

  @HostListener('document:keydown.escape')
  onCloseClick(): void {
    this.data.currentSnackBar.dismiss();
  }
}
